<template>
    <div v-if="hasField('Capacites')">
        <div class="tabulation-title" v-if="capacities.length">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon> Capacités
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <div class="mt-3 d-flex justify-content-between flex-wrap">
                <div v-for="capacity in capacities" style="min-width: 370px">
                    <v-text-field v-model="capacity.value" :label="capacity.label" type="number" step="2" outlined>
                    </v-text-field>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"

export default {
    name: "Capacities",
    methods: {
        mergeProviderCapacities() {
            this.provider.capacities.forEach(capacity => {

                if (capacity.element !== undefined) {
                    let element = this.capacities.find(elt => elt.id === capacity.element.id)

                    if (element !== undefined) {
                        this.$set(element, 'value', capacity.value)
                    }
                }
            })
        },
        updateProviderCapacities() {
            this.provider.capacities = this.capacities.filter(capacity => {
                return capacity.value !== undefined && capacity.value !== ''
            })
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'capacities', 'disabled', 'fields']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode'])
    },
    watch: {
        capacities: {
            handler() {
                this.updateProviderCapacities()
            },
            deep: true
        }
    },
    created() {
        this.mergeProviderCapacities()
    }
}
</script>